import {
  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer,
} from 'recharts'

function shortNaira(v) {
  if (v >= 1_000_000) return `₦${(v / 1_000_000).toFixed(1)}M`
  if (v >= 1_000) return `₦${(v / 1_000).toFixed(0)}k`
  return `₦${v}`
}

function shortDate(dateStr) {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-NG', {
    day: 'numeric', month: 'short',
  })
}

const tooltipStyle = {
  borderRadius: 8,
  border: 'none',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
  fontSize: 12,
}

export default function RevenueChart({ data }) {
  if (!data.length) return null

  const chartData = data.map((d) => ({ ...d, label: shortDate(d.date) }))

  return (
    <div className="bg-white rounded-xl shadow p-4">
      <p className="text-sm font-semibold text-gray-700 mb-3">Revenue & Profit Trends</p>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={chartData} margin={{ top: 4, right: 4, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: '#9ca3af' }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            tickFormatter={shortNaira}
            tick={{ fontSize: 11, fill: '#9ca3af' }}
            tickLine={false}
            axisLine={false}
            width={58}
          />
          <Tooltip
            formatter={(value, name) => [shortNaira(value), name]}
            contentStyle={tooltipStyle}
          />
          <Legend
            wrapperStyle={{ fontSize: 12 }}
            iconType="circle"
            iconSize={8}
          />
          <Line
            type="monotone"
            dataKey="revenue"
            stroke="#16a34a"
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
            name="Revenue"
          />
          <Line
            type="monotone"
            dataKey="netProfit"
            stroke="#9333ea"
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
            name="Net Profit"
          />
          <Line
            type="monotone"
            dataKey="amountToRemit"
            stroke="#2563eb"
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
            name="To Remit"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
